<div class="companies-strip">
    <div class="strip-content">
        @for (chunk of dupedImageRows(); track $index; let even = $even) {
            <div class="company-logos" [class.reversed]="even">
                @for (el of chunk; track $index) {
                    <div class="logo-item rounded-sm overflow-hidden">
                        <img [src]="el.image" alt=""/>
                    </div>
                }
            </div>
        }
    </div>
</div>
